// Step-by-step authenticator instructions shared by agent and portal enrollment.
// People new to MFA do not know the QR code is for an app on their phone, not
// for the phone camera - so the steps say so before showing the code.
export function AuthenticatorSetup({
  qrDataUri,
  secret,
}: {
  qrDataUri: string;
  secret: string;
}) {
  return (
    <div className="space-y-4 rounded-[var(--radius-card)] border border-[var(--color-border)] bg-white p-4 text-sm">
      <div>
        <p className="font-semibold text-[var(--color-header)]">
          Set up two-step sign-in
        </p>
        <p className="mt-1 text-[var(--color-muted)]">
          Signing in needs your password plus a 6-digit code from an
          authenticator app on your phone.
        </p>
      </div>
      <ol className="list-decimal space-y-3 pl-5 text-[var(--color-body)]">
        <li>
          <span className="font-semibold">Install an authenticator app</span> on
          your phone if you don't already have one. Any of these work: Microsoft
          Authenticator, Google Authenticator, Duo Mobile, Authy or 1Password.
        </li>
        <li>
          <span className="font-semibold">
            Open the app and add a new account.
          </span>{" "}
          Look for a<span className="font-semibold"> +</span> button or "Add
          account", then choose{" "}
          <span className="font-semibold">Scan a QR code</span>. In Microsoft
          Authenticator pick "Other account"; in Duo Mobile pick "Use QR code".
          <div className="mt-3 flex flex-col items-start gap-4 sm:flex-row">
            <img
              src={qrDataUri}
              alt="QR code to scan with your authenticator app"
              className="h-40 w-40 shrink-0 rounded border border-[var(--color-border)]"
            />
            <div className="text-xs text-[var(--color-muted)]">
              <p>
                Scan this code{" "}
                <span className="font-semibold">
                  from inside the authenticator app
                </span>
                . Your phone's regular camera will not set it up.
              </p>
              <p className="mt-2">
                Can't scan it? Choose "Enter a setup key" in the app and type:
              </p>
              <p className="mt-1 break-all font-mono text-[var(--color-header)]">
                {secret}
              </p>
            </div>
          </div>
        </li>
        <li>
          <span className="font-semibold">Enter the code.</span> The app now
          shows a 6-digit code labelled "T3 Tick3ting" that changes every 30
          seconds. Type the current one into "Authenticator code" below.
        </li>
      </ol>
    </div>
  );
}
